import { withStyles } from '@material-ui/core/styles';
import { variables } from 'components/Theme/';

export default withStyles((theme) => ({
  tableStatus: {
    position: 'absolute',
    left: 0,
    top: 0,
    height: '100%',
    width: '0.65rem',
    zIndex: 10,
    borderRadius: 6,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    ['&.ativo' as any]: {
      backgroundColor: variables.palette.success.main,
    },
    ['&.inativo' as any]: {
      backgroundColor: variables.palette.error.main,
    },
    [theme.breakpoints.down('md')]: {
      width: '0.75rem',
      height: '0.75rem',
      top: '50%',
      left: '50%',
      borderRadius: 30,
      transform: 'translate3d(-50%, -50%, 0)',
      position: 'relative',
    },
  },
}));
